import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import SafeDrivingGuide from '@di-shared/features/safe-driving-vDSP/SafeDrivingGuide/index';

function SafeDrivingGuidePage() {
  const {t} = useInferableTranslation();

  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <SafeDrivingGuide />
    </div>
  );
}

export default SafeDrivingGuidePage;
